import React, { useContext, useEffect, useState } from "react"
import HubSpot from "../../utils/HubSpot"
import moment from "moment-timezone"
import isEmail from "validator/lib/isEmail"
import PhoneNumber, { isValidPhone } from "../PhoneNumber"
import { hqs, managers, noResults, teamSuites } from "./form_data"
import qs from "query-string"
import "./index.less"
import { SpaceProfileContext } from "../SpaceProfile/context"
import SubmitButton from "../SubmitButton"
import MarketingConsentCheckbox from "../MarketingConsentCheckbox"
import submitToMailChimp from "../../utils/submitToMailChimp"

const isDev = (value) => {
  return process.env.NODE_ENV === "development" ? value : ""
}

const SearchResultsForm = ({
  hqSuites = false,
  resultsCount = 0,
  teamSize = 1,
  searchParams = {},
  formTitle = "",
  pageData = {},
  emailTitleOverride = "Workplace One - Inquiry",
}) => {
  const {
    commonData: { location },
  } = useContext(SpaceProfileContext)

  const [formSent, setFormSent] = useState(false)
  const [progress, setProgress] = useState(false)
  const [error, setError] = useState(false)
  const [manager, setManager] = useState(managers.Toronto)
  const [title, setTitle] = useState(noResults(pageData).title)
  const [text, setText] = useState(noResults(pageData).text)
  const [formType, setFormType] = useState("")
  const [interestedIn, setInterestedIn] = useState("N/A")
  const [marketingEmails, setMarketingEmails] = useState(true)

  const params =
    typeof window !== "undefined" ? qs.parse(window.location.search) : {}

  useEffect(() => {
    if (params.location && managers[params.location]) {
      setManager(managers[params.location])
    } else if (
      location &&
      location.id === "74d90e2e-ab4b-414f-97d2-3c57f2cc422a"
    ) {
      setManager(managers.Kitchener)
    } else {
      setManager(managers.Toronto)
    }
  }, [params])

  useEffect(() => {
    setFormType("N/A")
    setInterestedIn("N/A")
    if (hqSuites) {
      setTitle(hqs(pageData).title)
      setText(hqs(pageData).text)
      setFormType("HQ Suites")
      setInterestedIn("HQ Suites")
    } else {
      if (resultsCount <= 0) {
        if (teamSize > 12 || Number(teamSize) > 12) {
          setTitle(teamSuites(pageData).title)
          setFormType("Team suites with no results")
          setInterestedIn("Team suites")
        } else {
          setFormType(`${searchParams.space_type} with no results`)
          setInterestedIn(searchParams.space_type)
          setTitle(noResults(pageData).title)
        }
        setText(noResults(pageData).text)
      } else {
        setFormType(
          `${searchParams.space_type} with ${resultsCount} result${
            resultsCount > 1 ? "s" : ""
          }`
        )
        setInterestedIn(searchParams.space_type)
        if (teamSize > 12) {
          setFormType(
            `Team suites with ${resultsCount} result${
              resultsCount > 1 ? "s" : ""
            }`
          )
          setTitle(teamSuites(pageData).title)
          setText(teamSuites(pageData).text)
        }
      }
    }
  }, [hqSuites, resultsCount, teamSize])

  const [name, setName] = useState(isDev("Mahesh"))
  const [email, setEmail] = useState(isDev("hello+1@worksimply.com"))
  const [message, setMessage] = useState(isDev("Test from Worksimply"))
  const [phone, setPhone] = useState(isDev("7147147147"))

  useEffect(() => {
    setFormSent(false)
    setProgress(false)
  }, [searchParams])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProgress(true)

    let move_in_date = ""
    if (searchParams.move_in_date) {
      if (moment(searchParams.move_in_date, "YYYY-MM-DD", true).isValid()) {
        move_in_date = moment(searchParams.move_in_date, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        )
      } else {
        move_in_date = moment().format("YYYY-MM-DD")
      }
    }

    const data = {
      fullname: name,
      email,
      message,
      phone,
      location_interest_form: searchParams.location || location.space_name,
      team_size: searchParams.current_staff || searchParams.team_size || 0,
      move_in_date,
      space_type: searchParams.space_type,
      // search_results_count: hqSuites
      //   ? cmsLocations.length
      //   : activeSpaces.length,
      interested_in: formType,
    }

    let toEmail = location?.get_in_touch_emails || pageData?.formEmail

    const formData = {
      email,
      toEmail,
      formData: [
        { label: "Name", value: name },
        { label: "Email", value: email },
        { label: "Phone number", value: phone },
        { label: "Message", value: message },
        {
          label: "Searched location",
          value: searchParams.location || location.space_name || "N/A",
        },
        {
          label: "Searched space type",
          value: searchParams.space_type || "N/A",
        },
        {
          label: "Searched team size",
          value: searchParams.current_staff || searchParams.team_size || "N/A",
        },
        { label: "Searched move-in date", value: move_in_date || "N/A" },
        { label: "Interested in", value: interestedIn },
      ],
    }

    const status = await HubSpot(
      "2263af6d-5b08-4e97-801a-c21f644f9331",
      data,
      formData,
      formTitle || "Locations page",
      emailTitleOverride
    )

    await submitToMailChimp(marketingEmails, name, email)

    if (status) {
      setFormSent(true)
    } else {
      setError(true)
    }
    setMessage("")
    setPhone("")
    setEmail("")
    setName("")
    setProgress(false)
  }

  if (resultsCount > 0 && Number(teamSize) <= 12) {
    return null
  }

  return (
    <div className="location-results-form">
      <div className="form-inner">
        <div className={`form-message ${formSent ? "form-sent" : ""}`}>
          <h5 className={`mt-0`}>
            Thanks for getting in touch with us. An office space expert will
            reach out to you as soon as possible.{" "}
          </h5>
        </div>
        <div className={`form-body ${formSent ? "form-sent" : ""}`}>
          <div className="location-form-header row">
            <div className="col-sm-6">
              <div className="left">
                <img src={manager.image} alt={manager.name} />
                <div>
                  <p className={"name"}>{manager.name}</p>
                  <p className="designation">{manager.title}</p>
                </div>
              </div>
            </div>
            {hqSuites && (
              <div className="col-sm-6 text-sm-end">
                <a
                  href={`/solutions/hq-suites`}
                  className={"btn btn-link chev-right mt-3 mt-sm-0"}
                  target={"_blank"}
                  rel="noopener noreferrer"
                >
                  Explore HQ Suites
                </a>
              </div>
            )}
          </div>
          <h4>{title}</h4>
          <p>{text}</p>

          <form action="" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    name={"name"}
                    placeholder={"Full name *"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="email"
                    name={"email"}
                    placeholder={"Work email *"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <PhoneNumber
                    setPhone={setPhone}
                    value={phone}
                    name={"phone"}
                    placeholder={"Phone Number *"}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    name={"notes"}
                    placeholder={"Notes"}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-sm-12" style={{ marginTop: "-12px" }}>
                <MarketingConsentCheckbox
                  checked={marketingEmails}
                  setChecked={setMarketingEmails}
                />
              </div>

              <div className="col-sm-12">
                <SubmitButton
                  disabled={
                    progress ||
                    !name ||
                    !email ||
                    !isEmail(email) ||
                    !isValidPhone(phone, true)
                  }
                  progress={progress}
                  label={"Get in Touch"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SearchResultsForm
